import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { msalConfig } from './msal-config';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MSAL_INSTANCE, MsalService, MsalGuard, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';

export function MSALInstanceFactory() {
  return new PublicClientApplication(msalConfig);
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect, // Redirect
    authRequest: {
      scopes: ['user.read']
    }
  };
}

async function main() {
  const msalInstance = new PublicClientApplication(msalConfig);
  await msalInstance.initialize();

  bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [
      provideZoneChangeDetection(),...(appConfig.providers || []),
      {
        provide: MSAL_INSTANCE,
        useValue: msalInstance
      },
      {
        provide: MSAL_GUARD_CONFIG,
        useFactory: MSALGuardConfigFactory
      },
      MsalService,
      MsalGuard,
      MsalBroadcastService
    ]
  }).catch((err) => console.error(err));
}

main();
